<template>
  <div class="w3-container">
      <h1>admin PhpView</h1>
 </div>  
</template>
<script>
export default {
    name:'PhpView'
}
</script>
<style scoped>

</style>